import React from 'react';

const DataHandlerContext = React.createContext({});

export default DataHandlerContext